/**
 * El dropdown de la factura lista Métodos de pago de Opciones.
 * Un nombre conocido se guarda con el código que ya usa el cierre.
 * Un nombre nuevo se guarda tal cual: el cierre todavía no lo clasifica.
 *
 * Run: npx tsx --test src/modules/Ventas/metodoPagoCatalogo.test.ts
 */

export type MetodoPagoOpcion = {
  codigo: string;
  tipo: string;
  metodoPago: string;
};

export function foldMetodoPago(value: string): string {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

/** Código interno si el tipo nombra un medio que la factura y el cierre ya conocen. */
export function codigoMedioConocido(tipo: string): string | null {
  const s = foldMetodoPago(tipo);
  if (s.includes("debito")) return "tarjeta_debito";
  if (s.includes("credito")) return "tarjeta_credito";
  if (s.includes("transfer")) return "transferencia";
  if (s.includes("cheque")) return "cheque";
  if (s.includes("dolar")) return "dolares";
  if (s.includes("efectivo")) return "efectivo";
  return null;
}

export function metodoPagoParaFactura(tipo: string): string {
  return codigoMedioConocido(tipo) ?? String(tipo || "").trim();
}

export function opcionesDesdeCatalogo(
  rows: Array<{ codigo?: string; tipo?: string; activo?: boolean }>,
): MetodoPagoOpcion[] {
  const out: MetodoPagoOpcion[] = [];
  for (const row of rows || []) {
    const codigo = String(row.codigo || "").trim();
    const tipo = String(row.tipo || "").trim();
    if (!codigo || !tipo || row.activo === false) continue;
    out.push({ codigo, tipo, metodoPago: metodoPagoParaFactura(tipo) });
  }
  return out;
}

/** Misma lista de hoy, por si Opciones no responde. */
export const METODOS_PAGO_FACTURA_FALLBACK: MetodoPagoOpcion[] = [
  { codigo: "efectivo", tipo: "Efectivo", metodoPago: "efectivo" },
  { codigo: "transferencia", tipo: "Transferencia Bancaria", metodoPago: "transferencia" },
  { codigo: "tarjeta_credito", tipo: "Tarjeta de Crédito", metodoPago: "tarjeta_credito" },
  { codigo: "tarjeta_debito", tipo: "Tarjeta de Débito", metodoPago: "tarjeta_debito" },
  { codigo: "cheque", tipo: "Cheque", metodoPago: "cheque" },
  { codigo: "dolares", tipo: "Dólares", metodoPago: "dolares" },
];

export function metodoInicial(
  opciones: MetodoPagoOpcion[],
): { metodoPago: string; metodoCodigo?: string; metodoTipo?: string } {
  const elegido = opciones.find((o) => o.metodoPago === "efectivo") ?? opciones[0];
  if (!elegido) return { metodoPago: "efectivo", metodoTipo: "Efectivo" };
  return {
    metodoPago: elegido.metodoPago,
    metodoCodigo: elegido.codigo,
    metodoTipo: elegido.tipo,
  };
}

export function reasignarCodigoCatalogo(
  metodoCodigo: string | undefined,
  metodoPago: string,
  opciones: MetodoPagoOpcion[],
): string | undefined {
  if (metodoCodigo && opciones.some((o) => o.codigo === metodoCodigo)) return metodoCodigo;
  return opciones.find((o) => o.metodoPago === metodoPago)?.codigo;
}
